import { resolveMediaUrl } from '../../../utils/mediaUrl';

const GlobalMarketCardEditor = ({
  item,
  index,
  values,
  onChange,
  onIconUpload,
  isUploading = false,
}) => (
  <article className="rounded-md border border-[#e4d9c8] bg-white p-4">
    <div className="mb-4 flex items-start justify-between gap-3 border-b border-[#e4d9c8] pb-3">
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-[#e4d9c8] bg-[#faf8f4]">
          <img
            src={resolveMediaUrl(item.url)}
            alt={item.altText || ''}
            className="h-6 w-6 object-contain"
          />
        </div>
        <div className="min-w-0">
          <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-[#6b635c]">
            Market {index}
          </p>
          <p className="truncate text-sm font-semibold text-[#130705]">
            {values.name || item.altText || 'Market card'}
          </p>
          {values.linkUrl ? (
            <p className="mt-0.5 truncate text-[11px] text-[#a8a098]">{values.linkUrl}</p>
          ) : null}
        </div>
      </div>

      <label
        className={`shrink-0 cursor-pointer rounded-md border border-[#e4d9c8] bg-[#faf8f4] px-3 py-1.5 text-[12px] font-medium text-[#130705] transition hover:bg-white ${
          isUploading ? 'pointer-events-none opacity-60' : ''
        }`}
      >
        {isUploading ? 'Uploading…' : 'Change icon'}
        <input
          type="file"
          accept="image/*,.svg,.ico"
          className="hidden"
          disabled={isUploading}
          onChange={onIconUpload}
        />
      </label>
    </div>

    <div className="grid gap-3 sm:grid-cols-2">
      <div>
        <label className="mb-1.5 block text-[12px] font-medium text-[#6b635c]">Name</label>
        <input
          type="text"
          value={values.name || ''}
          onChange={(event) => onChange({ ...values, name: event.target.value })}
          className="w-full rounded-md border border-[#d8cfc0] bg-white px-3 py-2 text-sm outline-none focus:border-[#785E32]"
        />
      </div>
      <div>
        <label className="mb-1.5 block text-[12px] font-medium text-[#6b635c]">Items</label>
        <input
          type="text"
          value={values.items || ''}
          onChange={(event) => onChange({ ...values, items: event.target.value })}
          className="w-full rounded-md border border-[#d8cfc0] bg-white px-3 py-2 text-sm outline-none focus:border-[#785E32]"
        />
      </div>
    </div>
  </article>
);

export default GlobalMarketCardEditor;
